export function orderByCreatedAtDesc(a, b) {
  return new Date(b.createdAt) - new Date(a.createdAt);
}

export function orderByCreatedAtAsc(a, b) {
  return new Date(a.createdAt) - new Date(b.createdAt);
}
